<template>
   <div class="fusion-time bg-light-purple container-fluid">
      <div class="content">
         <div v-for="(item, index) in getTimeExampleContent" :key="index" class="row">
            <div v-if="index === 0" class="col-12">
               <div class="main-content-block">
                  <h1 class="mb-1">{{ item.header }}</h1>
                  <div class="marked-header mb-3" v-html="markedRender(item.longDescription)" />
               </div>
            </div>
            <div v-else class="col-12 mb-6">
               <h2 class="mb-3">{{ item.header }}</h2>

               <div class="card-deck card-deck-special">
                  <div v-for="(itemB, _index) in item.body" :key="_index" class="card ">
                     <router-link :to="itemB.url" active-class="active" class="card-content">
                        <div class="card-header d-flex justify-content-center align-items-center">
                           <div class="image-container">
                              <img
                                 :src="itemB.rasterSource.file.url"
                                 :alt="itemB.header"
                                 class="card-img-top img img-fluid"
                              />
                           </div>
                        </div>
                        <div class="card-body ">
                           <h2 class="card-title bold mb-0">{{ `${itemB.header}` }}</h2>
                        </div>
                     </router-link>
                  </div>
               </div>
            </div>
         </div>
      </div>
   </div>
</template>

<script>
import { mapState } from 'vuex';
import metaGenerator from '../../util/meta.js';

export default {
   name: 'FusionTimeExampleOverview',
   computed: {
      ...mapState(['fusionTimeExamplesData']),
      getTimeExampleContent() {
         return this.fusionTimeExamplesData.content ? this.fusionTimeExamplesData.content : false;
      },
   },
   data: () => ({
      isClient: false,
   }),
   asyncData({ store }) {
      return Promise.all([store.dispatch('FUSIONTIME_EXAMPLES_FETCH')]);
   },

   metaInfo() {
      return metaGenerator(this.fusionTimeExamplesData);
   },

   mounted() {
      this.isClient = true;
   },
   methods: {},
   // components: {
   //    // NotFound,
   // },
};
</script>

<style lang="scss" scoped>
@import '../../util';
.content {
   overflow: hidden;
   padding: 30px 0;

   @include media-breakpoint-up(sm) {
      padding: 30px;
   }

   @include media-breakpoint-up(md) {
      padding: 50px 30px 40px 30px;
   }

   @include media-breakpoint-up(lg) {
      padding: 50px 25px 50px 25px;
   }
   @include media-breakpoint-up(xl) {
      padding: 50px 30px 50px 30px;
   }
}
.card-deck-special {
   .card {
      background: none;
      border-radius: 0;
      margin: 0;
      padding: 10px 15px 20px;

      flex: 0 0 auto;
      min-width: 100%;
      max-width: 100%;

      @media (min-width: 567px) {
         flex: 0 0 auto;
         min-width: 50%;
         max-width: 50%;
      }

      @media (min-width: 1200px) {
         flex: 0 0 auto;
         min-width: 33.33%;
         max-width: 33.33%;
      }
      // @media (min-width: 1440px) {
      //    flex: 0 0 auto;
      //    min-width: 25%;
      //    max-width: 25%;
      // }

      .card-header {
         padding: 10px 10px 0 10px;
      }

      .card-text {
         color: #686980;
         font-size: 16px;
         letter-spacing: 0.23px;
         line-height: 24px;
      }

      p.card-text {
         color: #212344;
         font-weight: 600;
      }

      .card-title {
         font-size: 16px;
         letter-spacing: 0.23px;
         line-height: 20px;
         color: #212344;
      }

      .card-content {
         height: 100%;
         background: #fff;
         border-radius: 5px;
         box-shadow: 0 6px 14px 0 rgba(33, 35, 68, 0.05) !important;

         &.explore-maps-content {
            width: auto;
            transition: all 0.2s ease;
            text-decoration: none;
            &:hover {
               transform: translateY(-4px);
               transition: all 0.2s ease;
            }
         }
         .explore-maps {
            height: 100%;
            width: auto;
         }
      }

      a.card-content {
         transition: all 0.2s ease;
         text-decoration: none;
         &:hover {
            transform: translateY(-4px);
            transition: all 0.2s ease;
         }
      }

      .card-img-top {
         height: 200px;
      }

      &.slick {
         .card-header {
            padding: 0;
            height: 100%;
         }
         a {
            display: block;
            padding: 15px 15px 15px 5px;
            h2 {
               margin: 0;
            }
         }
         .img-container {
            img {
               height: 55px;
            }
         }
      }
   }
}
</style>
